/* 🤖 this file was generated by svg-to-ts */
export const matIconViewArray: {
  name: 'view-array';
  data: string;
} = {
  name: 'view-array',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 7v10H9V7h6zm6-2h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z"/></svg>`
};
